import React from 'react';
import classes from './Backdrop.css';
const backdrop = (props) => {
   let backdrop = null;
   if(props.show) {
      backdrop = <div onClick={props.clicked} className={classes.appBackdrop} onclick="hideDrawer()"></div>;
   }
   return backdrop;
};

export default backdrop;


// WEBPACK FOOTER //
// ./src/components/UI/Backdrop/Backdrop.js